import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useHistory } from "react-router-dom";

import { AuthContext } from "../../contexts/AuthContext";
import GuestUserIcon from "../Icons/GuestUser";
import "./Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const history = useHistory();
  const { handleLogout, isLoggedIn, username, email, profileImage, isPremium } = useContext(AuthContext);
  const ref = useRef();

  const handleProfileClick = () => {
    if (!isLoggedIn) {
      history.push("/login");
      return;
    }
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    // Function to handle clicks outside of the menu
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    }

    // Attach the listener to the document
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/"><h1>Poker Planning</h1></Link>
        <div onClick={handleProfileClick} className="profile-section" ref={ref}>
          {profileImage ? (
            <img 
              src={profileImage}
              alt="Profile"
              className="profile-image"
              
            />) : <GuestUserIcon className="profile-image" />}
          {isLoggedIn && isMenuOpen && (
            <div className="profile-menu">
              <div className="profile-info">
                <img 
                  src={profileImage}
                  alt="Profile"
                  className="menu-profile-image"
                />
                <div className="user-details">
                  <h3>{username}</h3>
                  <p>{email}</p>
                </div>
              </div>
              <ul className="menu-items">
                {isPremium && (
                  <Link to="/profile"><li>My Profile</li></Link>
                )}
                <li onClick={handleLogout}>Logout</li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header; 
